import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React,{Suspense} from "react";
import StockTransfer from "./stockTransfer/StockTransfer";
import DamagedProducts from "./pages/saleReturn/DamagedProducts";
import ExchangeProduct from "./pages/saleReturn/exchangeProducts/ExchangeProduct";
import DiscountRules from "./pages/discountRules/DiscountRules";
import DiscountForm from "./pages/discountRules/DiscountForm";
import Profitability from "./pages/profitability/Profitability";
import Stockstatus from "./pages/stockstatus/Stockstatus";
import ProfitRanking from "./pages/profitability/ProfitRanking";
// import ArcTabs from "./pages/Incentive/Incetives";
import SemiCircleTabs from "./pages/Incentive/Incetives";
import NewIncentives from "./pages/Incentive/NewIncentives";
import TermsAndConditions from "./stockTransfer/TermsAndConditions";
import TrackingDetails from "./stockTransfer/TrackingDetails";
import ProfitPlusDetails from "./pages/profitability/ProfitPlusDetails";
import QptMobile from "./pages/profitability/QptMobile";
import SpinAndWin from "./pages/SpinWheel/SpinAndWin";
import MissedCustomer from "./pages/profitability/MissedCustomer";
import PreviousDayTimeLine from "./pages/TimelinePages/PreviousDayTimeLine";
import AhaBidUsers from "./pages/AhaBidUsers/AhaBidUsers";
import FinanceReports from "./pages/FinanceReports/FinanceReports";
import RifahSpin from "./pages/SpinWheel/Rifah-spin-and-win";
import PushpaStickerEvent from "./pages/PushpaRajEvent/PushpaStickerEvent";
import CustomersTable from "./pages/PushpaRajEvent/PushpaCustomers";
// import QueueJobs from "./pages/HappiQueueJobs/QueueJobs";
// import HappiForm from "./pages/HappiDiscount/HappiDiscount";
import EstimationSlip from "./pages/HappiDiscount/HappiDiscount";
// import ExcelToJson from "./pages/TabsOffers/TabsOffers";
import SkeletonLoader from "./pages/HappiQueueJobs/SkeletonLoader";
import EstimationList from "./pages/HappiDiscount/EstimationList";
// import TabOffersUI from "./pages/TabsOffers/TabOffersUI";
import HappiCarees from "./pages/HappiCarriers/HappiCareers";
import Excelsheetupload from "./pages/TabsOffers/TabsOffers";
import Sidsriramspinwin from "./pages/SpinWheel/SidSriramSpinAndWin";
import SchemeTable from "./pages/SchemeReceivables/scheme_receivables";
import ProfitTable from "./pages/profitability/profitReport";
import CareersApplyPage from "./pages/HappiWebCareers/careers";
import AppliedJobList from "./pages/HappiWebCareers/AppliedJobsList";

const QueueJobs=React.lazy(()=>import('./pages/HappiQueueJobs/QueueJobs'))

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<DiscountRules/>} />
        <Route path="editrules/:id" element={<DiscountForm />} />
        <Route path="stocktransfer" element={<StockTransfer />}/>
        <Route path="createrule" element={<DiscountForm/>} />
        <Route path="damagedproducts" element={<DamagedProducts/>} />
        <Route path="exchangeproducts" element={<ExchangeProduct/>} />
        <Route path="profitability" element={false?<div className="d-flex justify-content-center align-items-center" style={{height:"100vh"}}>Under Maintenance</div>:<Profitability/>} />
        <Route path="stockstatus" element={<Stockstatus/>} />
        <Route path="profitranking" element={<ProfitRanking/>}/>
        <Route path='incentives' element={<SemiCircleTabs/>}/>
        <Route path='incentivesTesting' element={<NewIncentives/>}/>
        <Route path='termsandconditons' element={<TermsAndConditions/>}/>
        <Route path='trackingdetails' element={<TrackingDetails/>}/>
        <Route path='profitDetials' element={<ProfitPlusDetails/>}/>
        <Route path='qpt' element={<QptMobile/>}/>
        <Route path='spin-and-win' element={<SpinAndWin/>}/>
       < Route path='rifahspin' element={<RifahSpin/>}/>
        <Route path='missedcustomer' element={<MissedCustomer/>}/>
       <Route path="pushpacustomers" element={<CustomersTable/>}/>
        <Route path='ahausers' element={<AhaBidUsers/>}/> 
        <Route path='timelinereport' element={<PreviousDayTimeLine/>}/>   
        <Route path='financereports' element={<FinanceReports/>}/>
      <Route path='scheme_receivables' element={<SchemeTable/>}/>
      <Route path='profit_report' element={<ProfitTable/>}/>
       <Route path='happi_careers_page' element={<CareersApplyPage/>}/>
      <Route path='applied_jobs_List' element={<AppliedJobList/>}/>


        <Route path="pushpa" element={<PushpaStickerEvent/>}/>
        <Route path="queuejobs" element={
          <Suspense fallback={<SkeletonLoader/>}>
          <QueueJobs/>
          </Suspense>
          }/>
        <Route path="happidiscount" element={<EstimationSlip/>}/>
        <Route path="tablistupload" element={<Excelsheetupload/>}/>
        <Route path='estomationlist' element={<EstimationList/>}/>
        <Route path='sriramspinwin' element={<Sidsriramspinwin/>}/>

        <Route path='careers' element={<HappiCarees/>}/>
        {/* <Route path='tabsui' element={<TabOffersUI/>}/> */}



        <Route path="*" element={<><h1>Page Not Found</h1></>} />
      </Routes>
    </Router>
  );
}

export default App;
